import styled from 'styled-components';

const H0 = styled.h1`
  font-size: 48px;
  font-weight: 700;
  font-family: ${(props) => (props.stencil ? 'CeraStencil' : 'CeraPro')};
  margin: ${(props) => (props.marg ? props.marg : 0)};
  line-height: ${(props) => (props.lineHt ? props.lineHt : 42)}px;
  color: ${(props) => (props.col ? props.col : '#000')};
  ${(props) => props.size && `font-size: ${props.size};`}
  ${(props) => props.wid && `width: ${props.wid};`}
  text-align: ${(props) => (props.center ? 'center' : props.right ? 'right' : 'left')};
  font-weight: ${(props) =>
    props.weight ? `${props.weight}` : props.regular ? 400 : props.med ? 500 : 700};
`;

const H1 = styled.h1`
  font-size: 32px;
  font-weight: 700;
  font-family: ${(props) => (props.stencil ? 'CeraStencil' : 'CeraPro')};
  margin: ${(props) => (props.marg ? props.marg : 0)};
  line-height: ${(props) => (props.lineHt ? props.lineHt : 42)}px;
  color: ${(props) => (props.col ? props.col : '#000')};
  ${(props) => props.size && `font-size: ${props.size};`};
  ${(props) => props.wid && `width: ${props.wid};`};
  text-align: ${(props) => (props.center ? 'center' : props.right ? 'right' : 'left')};
  font-weight: ${(props) =>
    props.weight ? `${props.weight}` : props.regular ? 400 : props.med ? 500 : 700};
`;

const H2 = styled.h2`
  font-size: 28px;
  font-weight: 700;
  font-family: ${(props) => (props.stencil ? 'CeraStencil' : 'CeraPro')};
  margin: ${(props) => (props.marg ? props.marg : 0)};
  line-height: ${(props) => (props.lineHt ? props.lineHt : 36)}px;
  color: ${(props) => (props.col ? props.col : '#000')};
  ${(props) => props.size && `font-size: ${props.size}`};
  text-align: ${(props) => (props.center ? 'center' : props.right ? 'right' : 'left')};
  font-weight: ${(props) =>
    props.weight ? `${props.weight}` : props.regular ? 400 : props.med ? 500 : 700};

  ${(props) =>
    (props.wid || props.maxWid) &&
    `
    width: ${props.wid || 'auto'};
    max-width: ${props.maxWid || 'auto'};
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  `};
`;

const H3 = styled.h3`
  font-size: 24px;
  font-weight: 700;
  font-family: ${(props) => (props.stencil ? 'CeraStencil' : 'CeraPro')};
  margin: ${(props) => (props.marg ? props.marg : 0)};
  line-height: ${(props) => (props.lineHt ? props.lineHt : 30)}px;
  color: ${(props) => (props.col ? props.col : '#000')};
  ${(props) => props.size && `font-size: ${props.size}`};
  text-align: ${(props) => (props.center ? 'center' : props.right ? 'right' : 'left')};
  font-weight: ${(props) =>
    props.weight ? `${props.weight}` : props.regular ? 400 : props.med ? 500 : 700};

  ${(props) =>
    (props.wid || props.maxWid) &&
    `
    width: ${props.wid || 'auto'};
    max-width: ${props.maxWid || 'auto'};
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  `};
`;

const H4 = styled.h4`
  font-size: 20px;
  font-weight: 700;
  font-family: ${(props) => (props.stencil ? 'CeraStencil' : 'CeraPro')};
  margin: ${(props) => (props.marg ? props.marg : 0)};
  line-height: ${(props) => (props.lineHt ? props.lineHt : 24)}px;
  color: ${(props) => (props.col ? props.col : '#000')};
  ${(props) => props.size && `font-size: ${props.size}`};
  text-align: ${(props) => (props.center ? 'center' : props.right ? 'right' : 'left')};
  font-weight: ${(props) =>
    props.weight ? `${props.weight}` : props.regular ? 400 : props.med ? 500 : 700};
`;

const H5 = styled.h5`
  font-size: 18px;
  font-weight: 700;
  font-family: ${(props) => (props.stencil ? 'CeraStencil' : 'CeraPro')};
  margin: ${(props) => (props.marg ? props.marg : 0)};
  color: ${(props) => (props.col ? props.col : '#000')};
  ${(props) => props.size && `font-size: ${props.size}`};
  text-align: ${(props) => (props.center ? 'center' : props.right ? 'right' : 'left')};
  font-weight: ${(props) =>
    props.weight ? `${props.weight}` : props.regular ? 700 : props.med ? 500 : 400};
`;

const bodyStyles = (props) => `
  text-align: ${props.center ? 'center' : props.right ? 'right' : 'left'};
  font-size: ${props.size ? `${props.size}` : '16px'};
  ${props.ht && `height: ${props.ht};`};
  ${props.hideOverflow && 'overflow: hidden'};

  ${
    props.b0 &&
    `
    font-size: 18px;
    line-height: 24px;
  `
  };

  ${
    props.b2 &&
    `
    font-size: 14px;
    line-height: 18px;
  `
  };

  ${
    props.c1 &&
    `
    font-size: 12px;
    line-height: 16px;
  `
  };

  ${
    props.c2 &&
    `
    font-size: 10px;
    line-height: 14px;
  `
  };

  ${
    (props.wid || props.maxWid) &&
    `
    width: ${props.wid || 'auto'};
    max-width: ${props.maxWid || 'auto'};
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  `
  };
  font-weight: ${props.weight ? `${props.weight}` : props.bold ? 700 : props.med ? 500 : 400};
  font-family: ${props.stencil ? 'CeraStencil' : 'CeraPro'};
  margin: ${props.marg ? props.marg : '0'};
  ${props.col && `color: ${props.col};`};
  ${props.maxWid && `max-width: ${props.maxWid};`};
  ${props.lineHt && `line-height: ${props.lineHt};`};
  ${props.spacing && `letter-spacing: ${props.spacing};`};
  ${props.overflowWrap && `overflow-wrap: ${props.overflowWrap};`};
  ${props.textOverflow && `text-overflow: ${props.textOverflow};`};
  ${props.overflow && `overflow: ${props.overflow};`};
  ${props.wordBreak && `word-break: ${props.wordBreak};`};
  ${props.whiteSpace && `white-space: ${props.whiteSpace};`};
  ${props.ht && `height: ${props.ht};`};
  ${
    props.lineClamp &&
    `
    display: -webkit-box;
    -webkit-line-clamp: ${props.lineClamp};
    -webkit-box-orient: vertical;
    overflow: hidden;
  `
  };
`;

const BodyText = styled.p`
  ${(props) => bodyStyles(props)};
`;

const SpanText = styled.span`
  ${(props) => bodyStyles(props)};
`;

const Text = (props) => {
  function getStyle() {
    switch (true) {
      case props.spanned:
        return <SpanText {...props}>{props.children}</SpanText>;

      case props.h0:
        return <H0 {...props}>{props.children}</H0>;

      case props.h1:
        return <H1 {...props}>{props.children}</H1>;

      case props.h2:
        return <H2 {...props}>{props.children}</H2>;

      case props.h3:
        return <H3 {...props}>{props.children}</H3>;

      case props.h4:
        return <H4 {...props}>{props.children}</H4>;

      case props.h5:
        return <H5 {...props}>{props.children}</H5>;

      default:
        return (
          <BodyText {...props} ref={props.textRef}>
            {props.children}
          </BodyText>
        );
    }
  }

  return getStyle();
};

export default Text;
